import { render } from "./404.vue?vue&type=template&id=ae891966&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=ae891966&lang=scss&scoped=true"

import exportComponent from "E:\\hongjia\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae891966"]])

export default __exports__